import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { types as sdkTypes } from '../../util/sdkLoader';
import { formatMoney } from '../../util/currency';
import moment from 'moment';
import css from './ListingPage.css';
import { FIXED_DISCOUNT } from '../../util/types';
import sortBy from 'lodash/sortBy';

const { Money } = sdkTypes;
const SectionFeaturesMaybe = props => {
  const {
    publicData,
    intl,
    categoryOptions,
    subCategoryOptions,
    deliveryTypeOptions,
    cancellationConfig,
  } = props;
  if (!publicData) {
    return null;
  }
  const {
    category,
    subCategory,
    brand,
    deliveryType,
    deliveryFee,
    deliveryLocations,
    cancellation,
    dateOfManufacture,
    bondFee,
    discounts,
    seats,
    pricingType,
    minRent,
  } = publicData || {};
  const getDiscountValue = discountObject => {
    const { typeOfDiscount, discountPrice, discountRate } = discountObject;
    if (typeOfDiscount === FIXED_DISCOUNT) {
      const { amount, currency } = discountPrice;
      return formatMoney(intl, new Money(amount, currency));
    }
    return discountRate + '%';
  };
  const getDiscountDuration = discountObject => {
    const { duration, typeOfDuration } = discountObject;
    return intl.formatMessage(
      {
        id: 'SectionFeaturesMaybe.discountDuration',
      },
      {
        duration,
        typeOfDuration,
      }
    );
  };
  const discountObject = !!discounts ? JSON.parse(discounts) : null;
  const categoryTextId =
    categoryOptions.find(cate => cate.key === category) &&
    categoryOptions.find(cate => cate.key === category).labelId;
  const categoryObj = category && subCategoryOptions[category];
  const subCategoryTextId =
    categoryObj &&
    categoryObj.find(item => item.key === subCategory) &&
    categoryObj.find(item => item.key === subCategory).labelId;
  const deliveryId1 = deliveryType && deliveryType.includes(deliveryTypeOptions[0].key);
  const deliveryId2 = deliveryType && deliveryType.includes(deliveryTypeOptions[1].key);
  const cancellationId =
    cancellationConfig.find(item => item.key === cancellation) &&
    cancellationConfig.find(item => item.key === cancellation).labelId;
  const categoryLabel = intl.formatMessage({ id: 'ListingPage.categoryTitle' });
  const subCategoryLabel = categoryTextId
    ? intl.formatMessage(
        { id: 'ListingPage.subCategoryTitle' },
        { category: intl.formatMessage({ id: categoryTextId }) }
      )
    : null;
  const brandLabel = intl.formatMessage({ id: 'ListingPage.brandTitle' });
  const seatsLabel = intl.formatMessage({ id: 'ListingPage.seatsTitle' });
  const discountLabel = intl.formatMessage({ id: 'ListingPage.discountTitle' });
  const deliveryLabel = intl.formatMessage({ id: 'ListingPage.deliveryTitle' });
  const deliveryFeeLabel = intl.formatMessage({ id: 'ListingPage.deliveryFeeTitle' });
  const deliveryLocationsLabel = intl.formatMessage({ id: 'ListingPage.deliveryLocationsTitle' });
  const cancellationPolicyLabel = intl.formatMessage({ id: 'ListingPage.cancellationPolicyTitle' });
  const domLabel = intl.formatMessage({ id: 'ListingPage.domTitle' });
  const minimumRentalLabel = intl.formatMessage({ id: 'ListingPage.minimumRentalLabel' });
  const bondFeeLabel = intl.formatMessage({ id: 'ListingPage.bondFeeTitle' });
  const discountsList = discounts => {
    return sortBy(discounts, discount => discount?.durationByDay).map((d, index) => {
      return (
        <p className={css.discountValue}>
          <FormattedMessage
            id="SectionFeaturesMaybe.discountInfo"
            values={{
              value: getDiscountValue(d),
              duration: getDiscountDuration(d),
            }}
          />
          <br />
          {discounts.length > 1 && index !== discounts.length - 1 && (
            <FormattedMessage id="SectionFeaturesMaybe.or" />
          )}
        </p>
      );
    });
  };

  return (
    <div className={css.sectionFeatures}>
      <h2 className={css.featuresTitle}>
        <FormattedMessage id="ListingPage.featuresTitle" />
      </h2>
      {!!categoryTextId && (
        <div className={css.propertyWrapper}>
          <h3 className={css.propertyLabel}>{categoryLabel}:</h3>
          <p className={css.propertyValue}>{intl.formatMessage({ id: categoryTextId })}</p>
        </div>
      )}
      {!!subCategoryTextId && !!categoryTextId && (
        <div className={css.propertyWrapper}>
          <h3 className={css.propertyLabel}>{subCategoryLabel}:</h3>
          <p className={css.propertyValue}>{intl.formatMessage({ id: subCategoryTextId })}</p>
        </div>
      )}
      {!!brand && (
        <div className={css.propertyWrapper}>
          <h3 className={css.propertyLabel}>{brandLabel}:</h3>
          <p className={css.propertyValue}>{brand}</p>
        </div>
      )}
      {!!seats && (
        <div className={css.propertyWrapper}>
          <h3 className={css.propertyLabel}>{seatsLabel}:</h3>
          <p className={css.propertyValue}>{seats}</p>
        </div>
      )}
      {discountObject && (
        <div className={css.propertyWrapper}>
          <h3 className={css.discountLabel}>{discountLabel}:</h3>
          <div className={css.propertyValue}>{discountsList(discountObject)}</div>
        </div>
      )}
      {!!(bondFee && bondFee.amount && bondFee.currency) && (
        <div className={css.propertyWrapper}>
          <h3 className={css.propertyLabel}>{bondFeeLabel}:</h3>
          <p className={css.propertyValue}>
            {formatMoney(intl, new Money(bondFee.amount, bondFee.currency))}
          </p>
        </div>
      )}
      {(!!deliveryId1 || !!deliveryId2) && (
        <div className={css.propertyWrapper}>
          <h3 className={css.propertyLabel}>{deliveryLabel}:</h3>
          <p className={css.propertyValue}>
            {deliveryTypeOptions[0].label}
            {deliveryId1 ? (
              <span className={css.checkmark}>✓</span>
            ) : (
              <span className={css.crossmark}>⤫</span>
            )}
            <br />
            {deliveryTypeOptions[1].label}
            {deliveryId2 ? (
              <span className={css.checkmark}>✓</span>
            ) : (
              <span className={css.crossmark}>⤫</span>
            )}
            <br />
          </p>
        </div>
      )}
      {!!(deliveryFee && deliveryFee.amount !== undefined && deliveryFee.currency) && (
        <div className={css.propertyWrapper}>
          <h3 className={css.propertyLabel}>{deliveryFeeLabel}:</h3>
          <p className={css.propertyValue}>
            {formatMoney(intl, new Money(deliveryFee.amount, deliveryFee.currency))}
          </p>
        </div>
      )}
      {!!(deliveryLocations && deliveryLocations.length > 0) && (
        <div className={css.propertyWrapper}>
          <h3 className={css.propertyLabel}>{deliveryLocationsLabel}:</h3>
          <p className={css.propertyValue}>
            {deliveryLocations.map((item, index) => (
              <React.Fragment key={index}>
                <span>{item.suburb}</span>
                <br />
              </React.Fragment>
            ))}
          </p>
        </div>
      )}
      {!!cancellationId && (
        <div className={css.propertyWrapper}>
          <h3 className={css.propertyLabel}>{cancellationPolicyLabel}:</h3>
          <p className={css.propertyValue}>{intl.formatMessage({ id: cancellationId })}</p>
        </div>
      )}
      {!!dateOfManufacture && (
        <div className={css.propertyWrapper}>
          <h3 className={css.propertyLabel}>{domLabel}:</h3>
          <p className={css.propertyValue}>
            {moment(new Date(dateOfManufacture))
              .format('MMM DD YYYY')
              .toString()}
          </p>
        </div>
      )}
      {!!pricingType && !!minRent && (
        <div className={css.propertyWrapper}>
          <h3 className={css.propertyLabel}>{minimumRentalLabel}:</h3>
          <p className={css.propertyValue}>{`${minRent} ${pricingType}${
            minRent > 1 ? 's' : ''
          }`}</p>
        </div>
      )}
    </div>
  );
};
export default SectionFeaturesMaybe;
